import React from 'react';
import {Button} from "../global/Button";

export const Join = (props) => {
  const data = props.data || {};

  return (
    <section className="pt-lg-16 pb-lg-16 pt-md-21 pb-md-13 pt-18 pb-11">
      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-10 offset-xl-1">
            <div className="mb-4 mb-md-6 d-flex">
              <span className="zg-label bg-green me-2">{data.number}</span>
              <span className="zg-label bg-green">{data.subtitle}</span>
            </div>
          </div>
          <div className="col-12 col-md-7 col-xl-5 offset-xl-1">
            <h2 className="h3 mb-6 mb-md-0" dangerouslySetInnerHTML={{__html: data.title}}></h2>
          </div>

          <div className="col-12 col-md-4 col-lg-4 offset-lg-0 offset-md-1 col-xl-4">
            {data.text && (
              <p className="mb-6 mb-lg-8 zg-text-sm" dangerouslySetInnerHTML={{__html: data.text}}></p>
            )}
            {data.link?.url && data.link?.title && (
              <Button
                title={data.link.title}
                url={data.link.url}
                classes="btn-lg"
                external={data.link.target === '_blank'}
              />
            )}
          </div>


        </div>

      </div>
    </section>
  )
}
